import { createSelector } from 'reselect';

const selectPolicyDomain = (state) => state.policy;

export const selectCancellation = () =>
    createSelector(selectPolicyDomain, (substate) => {
        return substate.cancellation;
    });
